import { useNavigate } from "@core/routing/use-navigate";
import styled from "@emotion/styled";
import { Page } from "@ui/components/common/page";
import { PageHeader } from "@ui/components/common/page-header";
import { RoutesPath } from "@ui/navigation/routes";
import { colors } from "@ui/style/colors";
import { fonts } from "@ui/style/font";
import { getScrollbarStyle } from "@ui/style/scrollbar";
import React from "react";

interface DocumentViewerProps {
	title: string;
	content: string;
	headerLink: {
		label: string;
		to: string;
	};
}

export const DocumentViewer = ({ title, content, headerLink }: DocumentViewerProps): JSX.Element => {
	const navigate = useNavigate();
	return (
		<StyledPage>
			<PageHeader
				title={title}
				tertiaryButton={{ label: headerLink.label, onClick: () => navigate(headerLink.to as RoutesPath) }}
			/>
			<Container className="p-card">
				<div className="document-content" dangerouslySetInnerHTML={{ __html: content }} />
			</Container>
		</StyledPage>
	);
};

const Container = styled.div`
	padding: 32px;

	.document-content {
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		${getScrollbarStyle(8)};
	}

	.document-content h1 {
		font-family: ${fonts.header};
		font-size: 32px;
		font-weight: bold;
	}

	.document-content h2 {
		font-family: ${fonts.header};
		font-size: 24px;
		font-weight: bold;
	}

	.document-content h3 {
		font-family: ${fonts.header};
		font-size: 18px;
		font-weight: bold;
	}

	.document-content table {
		width: 100%;
		border-collapse: collapse;
	}

	.document-content th,
	.document-content td {
		padding: 6px 10px;
		vertical-align: top;
		border: 1px solid ${colors.grey};
	}
`;

const StyledPage = styled(Page)`
	width: min(calc(100vw - 40px), 832px);
	place-content: center;
`;
